/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((time || '') === '') {
      date = new Date()
    } else {
      if (typeof time === 'number') {
        date = new Date(time)
      } else {
        date = new Date(time.replace(new RegExp(/-/gm), '/'))
      }
      // if (('' + time).length === 10) time = parseInt(time) * 1000
    }
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['日', '一', '二', '三', '四', '五', '六'][value]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key] ? json[key] : '')
  })).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = difference / duration * 10
  setTimeout(() => {
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [{
  text: '今天',
  onClick(picker) {
    const end = new Date()
    const start = new Date(new Date().toDateString())
    end.setTime(start.getTime())
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近一周',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近一个月',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近三个月',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
    picker.$emit('pick', [start, end])
  }
}]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = source[keys].constructor === Array ? [] : {}
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4)
  if (date) random = random + Date.now()
  return random
}

export const pSBC = (p, from, to) => {
  //   if (typeof (p) !== 'number' || p < -1 || p > 1 || typeof (from) !== 'string' || (from[0] !== 'r' && from[0] !== '#') || (to && typeof (to) !== 'string')) return null // ErrorCheck
  //   if (!this.pSBCr) {
  //     this.pSBCr = (d) => {
  //       const l = d.length
  //       const RGB = {}
  //       if (l > 9) {
  //         d = d.split(',')
  //         if (d.length < 3 || d.length > 4) return null// ErrorCheck
  //         RGB[0] = i(d[0].split('(')[1]); RGB[1] = i(d[1]); RGB[2] = i(d[2]); RGB[3] = d[3] ? parseFloat(d[3]) : -1
  //       } else {
  //         if (l === 8 || l === 6 || l < 4) return null // ErrorCheck
  //         if (l < 6)d = '#' + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (l > 4 ? d[4] + '' + d[4] : '') // 3 or 4 digit
  //         d = i(d.slice(1), 16); RGB[0] = d >> 16 & 255; RGB[1] = d >> 8 & 255; RGB[2] = d & 255; RGB[3] = -1
  //         if (l === 9 || l === 5)RGB[3] = r((RGB[2] / 255) * 10000) / 10000; RGB[2] = RGB[1]; RGB[1] = RGB[0]; RGB[0] = d >> 24 & 255
  //       }
  //       return RGB
  //     }
  //   }

  //   const i = parseInt
  //   const r = Math.round
  //   let h = from.length > 9
  //   h = typeof (to) === 'string' ? to.length > 9 ? true : to === 'c' ? !h : false : h
  //   const b = p < 0
  //   p = b ? p * -1 : p
  //   to = to && to !== 'c' ? to : b ? '#000000' : '#FFFFFF'
  //   const f = this.pSBCr(from)
  //   const t = this.pSBCr(to)
  //   if (!f || !t) return null // ErrorCheck
  //   if (h) return 'rgb' + (f[3] > -1 || t[3] > -1 ? 'a(' : '(') + r((t[0] - f[0]) * p + f[0]) + ',' + r((t[1] - f[1]) * p + f[1]) + ',' + r((t[2] - f[2]) * p + f[2]) + (f[3] < 0 && t[3] < 0 ? ')' : ',' + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 10000) / 10000 : t[3] < 0 ? f[3] : t[3]) + ')')
  //   else return '#' + (0x100000000 + r((t[0] - f[0]) * p + f[0]) * 0x1000000 + r((t[1] - f[1]) * p + f[1]) * 0x10000 + r((t[2] - f[2]) * p + f[2]) * 0x100 + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 255) : t[3] > -1 ? r(t[3] * 255) : f[3] > -1 ? r(f[3] * 255) : 255)).toString(16).slice(1, f[3] > -1 || t[3] > -1 ? undefined : -2)
  // }

  // function (p, from, to) {
  if (typeof (p) !== 'number' || p < -1 || p > 1 || typeof (from) !== 'string' || (from[0] !== 'r' && from[0] !== '#') || (to && typeof (to) !== 'string')) {
    return null
  } // ErrorCheck
  if (!this.sbcRip) {
    this.sbcRip = (d) => {
      const l = d.length
      const RGB = {}
      if (l > 9) {
        d = d.split(',')
        if (d.length < 3 || d.length > 4) return null // ErrorCheck
        RGB[0] = i(d[0].split('(')[1])
        RGB[1] = i(d[1])
        RGB[2] = i(d[2])
        RGB[3] = d[3] ? parseFloat(d[3]) : -1
      } else {
        if (l === 8 || l === 6 || l < 4) return null // ErrorCheck
        if (l < 6) d = '#' + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (l > 4 ? d[4] + '' + d[4] : '') // 3 or 4 digit
        d = i(d.slice(1), 16)
        RGB[0] = d >> 16 & 255
        RGB[1] = d >> 8 & 255
        RGB[2] = d & 255
        RGB[3] = -1
        if (l === 9 || l === 5) {
          RGB[3] = r((RGB[2] / 255) * 10000) / 10000
          RGB[2] = RGB[1]
          RGB[1] = RGB[0]
          RGB[0] = d >> 24 & 255
        }
      }
      return RGB
    }
  }
  var i = parseInt
  var r = Math.round
  var h = from.length > 9
  h = typeof (to) === 'string' ? to.length > 9 ? true : to === 'c' ? !h : false : h
  var b = p < 0
  p = b ? p * -1 : p
  to = to && to !== 'c' ? to : b ? '#000000' : '#FFFFFF'
  var f = this.sbcRip(from)
  var t = this.sbcRip(to)
  if (!f || !t) return null // ErrorCheck
  if (h) return 'rgb' + (f[3] > -1 || t[3] > -1 ? 'a(' : '(') + r((t[0] - f[0]) * p + f[0]) + ',' + r((t[1] - f[1]) * p + f[1]) + ',' + r((t[2] - f[2]) * p + f[2]) + (f[3] < 0 && t[3] < 0 ? ')' : ',' + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 10000) / 10000 : t[3] < 0 ? f[3] : t[3]) + ')')
  else return '#' + (0x100000000 + r((t[0] - f[0]) * p + f[0]) * 0x1000000 + r((t[1] - f[1]) * p + f[1]) * 0x10000 + r((t[2] - f[2]) * p + f[2]) * 0x100 + (f[3] > -1 && t[3] > -1 ? r(((t[3] - f[3]) * p + f[3]) * 255) : t[3] > -1 ? r(t[3] * 255) : f[3] > -1 ? r(f[3] * 255) : 255)).toString(16).slice(1, f[3] > -1 || t[3] > -1 ? undefined : -2)
}
export function formatSeconds(value) {
  var secondTime = parseInt(value) // 秒
  var minuteTime = 0 // 分
  var hourTime = 0 // 小时
  if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
    // 获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60)
    // 获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60)
    // 如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      // 获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60)
      // 获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60)
    }
  }
  var result = '' + parseInt(secondTime) + '秒'

  if (minuteTime > 0) {
    result = '' + parseInt(minuteTime) + '分' + result
  }
  if (hourTime > 0) {
    result = '' + parseInt(hourTime) + '小时' + result
  }
  return result
}

export function formatSecondsToHS(value) {
  var secondTime = parseInt(value) // 秒
  var minuteTime = 0 // 分
  var hourTime = 0 // 小时
  if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
    // 获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60)
    // 获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60)
    // 如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      // 获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60)
      // 获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60)
    }
  }
  var result = ''

  if (minuteTime > 0) {
    result = '' + parseInt(minuteTime) + '′' + result
  }
  if (hourTime > 0) {
    result = '' + parseInt(hourTime) + ':' + result
  }
  return result
}
/**
 * 10进制转16进制
 */
export function num2Hex(num) {
  var hex_num = num.toString(16)
  return '0x' + hex_num
}

/**
 * 获取上传文件的地址
 * @param {*} path
 */
export const getUploadPath = (path) => {
  if (path === null || path === undefined || path === '') {
    return
  }
  const httpReg = /(http|https):\/\/([\w.]+\/?)\S*/
  const base64Reg = /data:image\/.*;base64,/
  // 若是完整地址或base64格式, 直接返回
  if (httpReg.test(path) || base64Reg.test(path)) {
    return path
  }
  const baseUpload = process.env.BASE_UPLOAD
  if (baseUpload.substr(baseUpload.length - 1, 1) === '/') {
    return baseUpload + path
  } else {
    return baseUpload + '/' + path
  }
}

/**
 * @param {文件路径} path
 * @param {文件类型} type 参数可为image和file 默认值 image
 */
export function getUploadFullPath(path, type = 'image') {
  if (path === null || path === undefined || path === '') {
    return
  }
  const httpReg = /(http|https):\/\/([\w.]+\/?)\S*/
  const base64Reg = /data:image\/.*;base64,/
  // 若是完整地址或base64格式, 直接返回
  if (httpReg.test(path) || base64Reg.test(path)) {
    return path
  }
  // 需要检查的文件地址集合
  const urlPrefixList = [
    'https://gmcx-security.obs.cn-south-1.myhuaweicloud.com:443/gatewayPlatform/upload/', // obs
    'http://122.9.41.188:9000/upload/'
  ]
  // 文件地址前缀
  let urlPrefix = 'https://gmcx-security.obs.cn-south-1.myhuaweicloud.com:443/gatewayPlatform/upload/'
  // 避免路径自带upload
  const filePath = path.indexOf('/upload/') !== -1 ? path.replace('/upload/', '') : path
  // 图片进行检测，文件则直接返回obs地址
  if (type === 'image') {
    // 遍历检查 拼接后的地址是否可访问
    urlPrefixList.forEach(prefix => {
      checkImgExists(prefix + filePath).then(res => {
        urlPrefix = prefix
        return urlPrefix + filePath
      }).catch((error) => {
        console.error('[getUploadFullPath]', error)
        urlPrefix = 'https://gmcx-security.obs.cn-south-1.myhuaweicloud.com:443/gatewayPlatform/upload/'
      })
    })
  }
  return urlPrefix + filePath
}

// 检测图片是否存在
export function checkImgExists(url) {
  return new Promise((resolve, reject) => {
    const imgObj = new Image()
    imgObj.src = url
    imgObj.onload = (res) => {
      resolve(res)
    }
    imgObj.onerror = (error) => {
      reject(error)
    }
  })
}

// 检测链接是否可以访问 无法检测图片 有跨域问题
export function checkLinkExists(url) {
  return fetch(url, {
    method: 'HEAD'
  }).then(response => {
    // 状态码在[200, 300)范围内表示成功访问
    return response.ok
  }).catch(() => {
    return false
  })
}

/**
 * 格式化金额，增加千分位
 * @param {*} value
 */
export const formatCurrency = (value) => {
  const num = value.toString()
  let decimals = ''
  // 判断是否有小数
  num.indexOf('.') > -1 ? decimals = num.split('.')[1] : decimals
  const ints = num.split('.')[0]
  const len = ints.length
  if (len <= 3) {
    return num
  } else {
    let temp = ''
    const remainder = len % 3
    decimals ? temp = '.' + decimals : temp
    if (remainder > 0) { // 不是3的整数倍
      return num.slice(0, remainder) + ',' + num.slice(remainder, len).match(/\d{3}/g).join(',') + temp
    } else { // 是3的整数倍
      return num.slice(0, len).match(/\d{3}/g).join(',') + temp
    }
  }
}

/**
 * 字符串左填充
 * @param {*} value
 * @param {*} paddingChar
 * @param {*} length
 */
export const leftPadding = (value, paddingChar, length) => {
  return (Array(length).join(paddingChar) + value).slice(-length)
}

/**
 * 字符串右填充
 * @param {*} value
 * @param {*} paddingChar
 * @param {*} length
 */
export const rightPadding = (value, paddingChar, length) => {
  return (value + Array(length).join(paddingChar)).slice(0, length)
}

/**
 * 获取URL参数
 * @param {*} name
 */
export function getQueryString(name) {
  const reg = `(^|[&?])${name}=([^&]*)(&|$)`
  let r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  } else {
    r = window.location.href.substr(1).match(reg)
    if (r != null) return unescape(r[2])
  }
  return null
}

export const sleep = (time) => {
  return new Promise((resolve) => setTimeout(resolve, time))
}

export function formatSecondsOverMinute(value) {
  var secondTime = parseFloat(value)// 秒
  var minuteTime = 0// 分
  // var hourTime = 0// 小时
  if (secondTime > 0) { // 如果秒数大于60，将秒数转换成整数
    // 获取分钟，除以60取整数，得到整数分钟
    minuteTime = (parseFloat((secondTime / 60) * 10) / 10).toFixed(1)
  }
  var result = ''
  if (minuteTime > 0) {
    result = '' + minuteTime + '分钟'
  }
  if (minuteTime === 0) {
    result = '' + minuteTime + '分钟'
  }
  if (result === '') {
    result = '0分钟'
  }
  return result
}

/**
 * @param {数组} list
 * @param {值} value
 * @returns
 */
export function getLabelByValue(list, value) {
  const filter_item = list.filter(item => {
    // 如果value是纯数字的情况下，转Number类型统一比较
    return !isNaN(Number(value)) ? Number(item.value) === Number(value) : item.value === value
  })
  return value !== undefined && value !== null && value !== '' && filter_item.length === 1 ? filter_item[0].label : null
}

/**
 * 处理文本内容，当内容为空时，返回置空符
 * @param {内容} content
 * @param {置空符} blankSymbol
 * @returns
 */
export function formatContent(content, blankSymbol = '-') {
  // 针对数字 0 的判断
  if (typeof content === 'number' || content) {
    return content
  } else {
    return blankSymbol
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js